// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5429":"3773663f","8428":"3773663f"}[chunkId] + ".chunk.css";
};